import { Winners } from "../../collections";

export class WinnersFantasy extends Winners {
	setApiUrl() {
		this.url = "classic_winners_monthly.json";
		return this;
	}
}

export default WinnersFantasy;